import React from 'react'
import styles from './style.module.scss';

function LiveStatus(liveStatus) {

  return (
    <div className={styles.livemain}>
        <span className={liveStatus?.liveStatus == "Not Yet" ? styles.nonlive : styles.live}></span> <span>{liveStatus?.liveStatus}</span>
        </div>
  )
}

export default LiveStatus